import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UsuarioService } from '../../services/usuario.service';
import { TextMaskModule } from 'angular2-text-mask';
import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AlertService } from '../../providers/alert.service';
import { ClienteService } from '../../services/cliente.service';

@Component({
	selector: 'app-cadastro-usuario',
	templateUrl: './cadastro-usuario.component.html',
	styleUrls: ['./cadastro-usuario.component.scss', '../../assets/less/all.less']
})
export class CadastroUsuarioComponent implements OnInit {
	public mask_cpf: TextMaskModule = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

	@ViewChild('fileInput') fileInput;
	is_edicao = false;
	private sub: any;
	id: any;
    funcionarios;
    clientes;
	usuario_form: FormGroup;
	roles =[
        {id:'admin', descricao: 'Administrador'},
        {id:'adminCliente', descricao: 'Administrador Cliente'},
        {id:'user', descricao: 'Usuário'},
    ]
	loading = false;
	usuario = {
		friendly_name: null,
		// password: null,
		username: null,
		cpf: null,
		email: null,
        role: null,
        cliente: null,
        id: null,
        profiles: [],
        perfis:[],
	}

	constructor(
        public usuario_service: UsuarioService,
        public cliente_service: ClienteService,
        public formBuilder: FormBuilder,
        public activated_router: ActivatedRoute,
        public ref: ChangeDetectorRef,
        public alerts: AlertService,
        private router: Router
	) {
		this.usuario_form = this.formBuilder.group({
            username: ['', Validators.required],
           // password: ['', Validators.nullValidator],
            friendly_name: ['', Validators.required],
            email: ['', Validators.required],
            role: ['', Validators.required],
            cliente: ['', Validators.required],
        })
	}

	ngOnInit() {
        this.getClientes()
		this.sub = this.activated_router.params.subscribe(params => {
            this.id = params['id'];
            // console.log(params)
            if (this.id != 0) {
                this.loading = true;
                this.is_edicao = true;
                this.usuario_service.getUsuariosByID(this.id)
                    .then(res => {
                        // console.log('res', res)
                        this.usuario.friendly_name = res['friendly_name'],
                        // password = res[''],
                        this.usuario.username = res['username'],
                        this.usuario.cpf = res['cpf'],
                        this.usuario.email = res['email'],
                        this.usuario.cliente = res['cliente'],
                        this.usuario.profiles = res['profiles'],
                        this.usuario.id = res['_id'],
                        this.usuario.perfis = res['profiles']
                        this.usuario.role = this.usuario.perfis[0],
                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;
                    })
                this.ref.detectChanges();
            }

        });
	}

	getListaRoles() {
        // this.usuario_service.getListaRoles().then(res => {
        //     this.roles = res['data'];
        // });
    }

    openUsuarios() {
        this.router.navigate(['/usuarios'])
    }
    
    getClientes(){
		this.cliente_service.getCliente('', '')
            .then(data => {
                if (data['items']) {
                    this.clientes = data['items'];
                    console.log(data);
                    // this.setPagination(data['_meta']['totalCount'], data['_meta']['currentPage'], data['_meta']['perPage']);
                    
                } else {
                    this.alerts.openAlert("Ops,", 'Ocorreu um erro, tente novamente mais tarde')
                }
            })
            .catch(error => {
				this.alerts.openAlert("Ops,", 'Ocorreu um erro, tente novamente mais tarde')
                // this.loading = false;
            });
	}
	
	salvar() {
        this.loading = true;
        this.usuario.profiles = []
        this.usuario['username'] = this.usuario['username'].replace(/[^\d]+/g, '');
        this.usuario.cpf = this.usuario.username
        this.usuario.profiles.push(this.usuario.role)
        // console.log(this.usuario['cpf'])
        if (this.is_edicao) {
            this.usuario_service.putusuario(this.usuario)
                .then(res => {
                    if (res['_id']) {
                        this.loading = false;
                        this.alerts.openAlert('Tudo certo!', 'Atualizado com sucesso');
                    } else {
                        this.loading = false;
                        this.alerts.openAlert("Ops,", 'Ocorreu um erro, tente novamente mais tarde')
                    }
                })
                .catch(error => {
                    this.loading = false;
                })
        } else {
            this.usuario_service.salvarUsuario(this.usuario)
                .then(res => {
                    if (res['_id']) {
                        this.loading = false;
                        this.alerts.openAlert('Tudo certo!', 'Salvo com sucesso');
                    } else {
                        this.loading = false;
                        this.alerts.openAlert("Ops,", 'Ocorreu um erro, tente novamente mais tarde')
                    }
                })
                .catch(error => {
                    this.loading = false;
                })
        }
    }

}
